import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useDeleteVoucher } from 'queries/voucher.query'

export function DeleteVoucherModal({ isOpen, onClose, voucher }) {
  const toast = useToast()
  const deleteMutation = useDeleteVoucher()

  const handleDelete = async () => {
    if (!voucher) return
    try {
      await deleteMutation.mutateAsync(voucher.id)
      toast({
        title: 'Voucher deleted',
        description: 'Promo code removed successfully',
        status: 'success',
        duration: 3000,
      })
      onClose()
    } catch (err) {
      toast({
        title: 'Failed to delete voucher',
        description: err?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Voucher</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete promo code <strong>{voucher?.code}</strong>?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={deleteMutation.isPending}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
